import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableFormGroup = ({ iError, iTouched, iValue, updateStore, rowIndex, values, setValues }) => {
  const onChange = React.useCallback(
    salida => {
      values.cuentaContable = salida.value
      values.cuentaContableInfo = salida.label
      values.cuentaContableTipoDocumento = salida.tipoDocumento
      values.flagCentroCosto = salida.flagCentroCosto
      values.esCuentaActivoFijo = salida.esActivoFijo
      values.tipoSocio = salida.tipoSocio
      values.moneda = salida.moneda

      if (!salida.value.startsWith('6') && !salida.value.startsWith('9')) {
        values.tipoAfectacion = ''
      }

      setValues(values)

      setTimeout(() => {
        updateStore()
        KeyEventUtil.leaveOnKeyEvent(salida.flagCentroCosto ? `select-det-centroCostoNivel1-${rowIndex}` : `input-det-importeDebe-${rowIndex}`)
      }, 200)
    },
    [values, setValues, updateStore, rowIndex]
  )

  const clickClear = React.useCallback(() => {
    values.cuentaContable = ''
    values.cuentaContableInfo = ''
    values.cuentaContableTipoDocumento = ''
    values.flagCentroCosto = false
    values.esCuentaActivoFijo = false
    values.tipoSocio = ''
    values.moneda = ''

    setValues(values)

    setTimeout(() => {
      updateStore()
      KeyEventUtil.leaveOnKeyEvent(`select-det-cuentaContable-${rowIndex}`)
    }, 200)
  }, [values, setValues, updateStore, rowIndex])

  return (
    <Form.Group>
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup id={`clearinput-det-cuentaContable-${rowIndex}`} iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id={`select-det-cuentaContable-${rowIndex}`} onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
